import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme:any) =>
  createStyles({
    root: {
      display: "flex",
      "& span:first-child":{
        background:" #737FA4",
        opacity: "0.3",
        borderRadius: "10px",
        transform: "matrix(-1, 0, 0, 1, 0, 0)",
        height:"1.625rem",
        width:"0.0625rem",
        marginRight:"0.9375rem"
      },
      "& span:last-child":{
        fontFamily: "Open Sans",
        fontStyle: "normal",
        fontHeight: "normal",
        fontSize: "1rem",
        lineHeight: "1.375rem",
        textAlign: "center",
        color: "#212121"
      }
    },
  }),
);
export function EndAdornment(props:{text:string}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span/>
      <span>{props.text}</span>
    </div>
  )
}
